<p-drawer [visible]="visible()" (onHide)="onDrawerHide()" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar w-full sm:w-[25rem]" header="Welcome">
    <div class="flex flex-col mx-auto md:mx-0">
        <span class="text-muted-color font-medium mb-1">
            {{authService.authUserComputedSignal()?.name}}
        </span>
        <span class="text-muted-color font-light text-sm mb-8">{{authService.authUserComputedSignal()?.email}}</span>

        <ul class="list-none m-0 p-0"> 
            <li>
                <a class="cursor-pointer flex border-surface mb-4 p-4 items-center border border-surface rounded-border hover:bg-emphasis transition-colors duration-150"
                    (click)="onProfileEditClick()">
                    <span>
                        <i class="pi pi-address-book text-xl text-primary"></i>
                    </span>
                    <div class="ml-4">
                        <span class="mb-2 font-semibold">Profile</span>
                        <p class="text-muted-color m-0">Edit your profile</p>
                    </div>
                </a>
            </li>         
            <li>
                <a class="cursor-pointer flex border-surface mb-4 p-4 items-center border border-surface rounded-border hover:bg-emphasis transition-colors duration-150"
                    (click)="onThemeChangeClick()">
                    <span>
                        <i class="pi pi-palette text-xl text-primary"></i>
                    </span>
                    <div class="ml-4">
                        <span class="mb-2 font-semibold">Themes</span>
                        <p class="text-muted-color m-0">Customize your experience</p>
                    </div>
                </a>
            </li>
            <li>
                <a class="cursor-pointer flex border-surface mb-4 p-4 items-center border border-surface rounded-border hover:bg-emphasis transition-colors duration-150"
                 (click)="onLogOutClick()">
                    <span>
                        <i class="pi pi-power-off text-xl text-primary"></i>
                    </span>
                    <div class="ml-4">
                        <span class="mb-2 font-semibold">Sign Out</span>
                        <p class="text-muted-color m-0">End your online session</p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</p-drawer>